import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ticketChannelStep } from "../../../../../../services/ticketChannelStep.service";
import { TTicketAutoInactiveRuleForm } from "./TicketAutoInactiveRuleSchema";

const translationPath = "page.settings.crm.ticketAutoInactivityRules.";

export const TicketChannelStep = memo(() => {
  const { t } = useTranslation();

  const { control } = useFormContext<TTicketAutoInactiveRuleForm>();

  const { sendRequest } = useFetch(ticketChannelStep);

  const [ticketChannelSteps, setTicketChannelSteps] = useState<ISelectType[]>(
    [],
  );

  const ticketChannel = useWatch({
    name: "ticketChannel",
    control,
  });

  const fetchTicketChannelSteps = useCallback(async () => {
    if (!ticketChannel?.id) {
      setTicketChannelSteps([]);
      return;
    }
    const { data, success } = await sendRequest({
      notFinish: true,
      id: ticketChannel.id,
    });
    if (data && success) {
      setTicketChannelSteps(data);
    }
  }, [sendRequest, ticketChannel]);

  useEffect(() => {
    fetchTicketChannelSteps();
  }, [fetchTicketChannelSteps, ticketChannel]);

  return (
    <>
      <Grid item xs={12} sm={6}>
        <AutoComplete
          getOptionLabel={(option) => {
            return option.name;
          }}
          size="small"
          label={t(translationPath + "ticket_channel_step")}
          name="ticketChannelStep"
          options={ticketChannelSteps}
        />
      </Grid>
    </>
  );
});
